module.exports = __webpack_public_path__ + "img/shao.b7b3334d.jpg";